import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 
import { any } from 'prop-types';

// ---------------
 
interface GroupsAccessState {
  groups: any[],
  selectedGroup: any, 
  selectedGroupBillingInfo: any, 
  selectedGroupAccess: any, 
  isRefreshGroups: boolean, 
  initialRendering: boolean, 
  isGroupInfoPopupOpened: boolean, 
}

// ---------------

const initialState: GroupsAccessState = {
    groups: [], 
    selectedGroup: null, 
    selectedGroupBillingInfo: null, 
    selectedGroupAccess: null, 
    isRefreshGroups: false, 
    initialRendering: true, 
    isGroupInfoPopupOpened: false,
};

// ---------------


export const groupsAccessSlice = createSlice({

  name: 'groupsAccess',

  initialState,

  reducers: {

    setGroups: (state, action: PayloadAction<any>) => { 

        state.groups = action.payload; 

    },
    setSelectedGroup: (state, action: PayloadAction<any>) => { 

      state.selectedGroup = action.payload; 

    },
    setSelectedGroupBillingInfo: (state, action: PayloadAction<any>) => { 

      state.selectedGroupBillingInfo = action.payload; 

    },
    setSelectedGroupAccess: (state, action: PayloadAction<any>) => { 

      state.selectedGroupAccess = action.payload; 

    },
    setIsRefreshGroups: (state, action: PayloadAction<boolean>) => { 

      state.isRefreshGroups = action.payload; 

    },
    setInitialRendering: (state, action: PayloadAction<boolean>) => {
  
      state.initialRendering = action.payload; 

    }, 
    setIsGroupInfoPopupOpened: (state, action: PayloadAction<boolean>) => {
  
      state.isGroupInfoPopupOpened = action.payload; 

    }, 
    resetGroupsAccess: (state) => { 
        
      state.groups = []; 
      state.selectedGroup = null;
      state.selectedGroupBillingInfo = null; 
      state.selectedGroupAccess = null; 
      state.isRefreshGroups = false;
      state.initialRendering = true; 
      state.isGroupInfoPopupOpened = false; 

    } 

  },

}); 

// ---------------

export const { 
  setGroups, 
  setSelectedGroup, 
  setSelectedGroupBillingInfo, 
  setSelectedGroupAccess, 
  setIsRefreshGroups, 
  setInitialRendering,
  setIsGroupInfoPopupOpened,  
  resetGroupsAccess,
} = groupsAccessSlice.actions;

export default groupsAccessSlice.reducer;